import _classCallCheck from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import MaskedPattern from './pattern.js';
import IMask from '../core/holder.js';
import '../_rollupPluginBabelHelpers-6b3bd404.js';
import '../core/utils.js';
import '../core/change-details.js';
import './base.js';
import '../core/continuous-tail-details.js';
import './pattern/input-definition.js';
import './factory.js';
import './pattern/fixed-definition.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './regexp.js';

/** Pattern which validates enum values */
var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedEnum, _MaskedPattern);
  var _super = _createSuper(MaskedEnum);
  function MaskedEnum() {
    _classCallCheck(this, MaskedEnum);
    return _super.apply(this, arguments);
  }
  _createClass(MaskedEnum, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      // TODO type
      if (opts.enum) opts.mask = '*'.repeat(opts.enum[0].length);
      _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, opts);
    }

    /**
      @override
    */
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this = this;
      return this.enum.some(function (e) {
        return e.indexOf(_this.unmaskedValue) >= 0;
      }) && _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this).apply(this, arguments);
    }
  }]);
  return MaskedEnum;
}(MaskedPattern);
IMask.MaskedEnum = MaskedEnum;
export { MaskedEnum as default };